import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Grid,
    TextField,
    Box,
    Button,
    IconButton,
    Card,
    CardMedia,
    FormControlLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Checkbox
} from '@mui/material';
import { subDays, isAfter, isToday, parseISO } from 'date-fns';
import { format } from 'date-fns';
import { DatePicker } from '@mui/x-date-pickers';
import EditImageModal from './editimage';
import { useNavigate, useParams } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { makeStyles } from '@mui/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import licenseApi from '../../../../../services/managelicense';
import fileuploadApi from '../../../../../services/managelicense';
import headerApi from '../../../../../services/managelicense';
import BillImg1 from '../../../../../assets/img/bill1.png';
import BillImg2 from '../../../../../assets/img/bill2.png';
import BillImg3 from '../../../../../assets/img/bill3.png';
import FrontEditBill from '../license_details_accordion/editbillpreview/front.js';
import EditBill from '../license_details_accordion/editbillpreview/editPrint.js';
import BackEditBill from '../license_details_accordion/editbillpreview/back.js';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';

import AddIcon from '@mui/icons-material/Add';

import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from '../../../../../redux/loader/actions';
import { showSnackbar } from '../../../../../redux/snackbar/actions';
import { getDecryptedCookie, removeCookie } from '../../../../../utils';
import LicenseModal from '../../manage_license/license_details_accordion/licensemodal';

const useStyles = makeStyles({
    animatedButton: {
        background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)',
        color: '#fff',
        padding: '10px 30px',
        fontSize: '16px',
        fontWeight: 'bold',
        textTransform: 'none',
        borderRadius: '5px',
        transition: 'transform 0.3s ease',
        '&:hover': {
            transform: 'scale(1.05)',
            background: 'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)'
        }
    },

    header: {
        background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)',
        color: '#fff',
        padding: '5px 15px',
        fontSize: '14px',
        fontWeight: 'bold',
        textTransform: 'none',
        borderRadius: '5px',
        transition: 'transform 0.3s ease',
        '&:hover': {
            transform: 'scale(1.05)',
            background: 'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)'
        }
    },

    underline: {
        display: 'inline-block',
        borderBottom: '2px solid #000',
        paddingBottom: '0.5px !important'
    },
    '@media print': {
        '@page': {
            size: 'A4 landscape',
            margin: '0',
            overFlow: 'auto'
        },
        body: {
            margin: '0',
            padding: '0',
            overFlow: 'auto'
        }
    }
});

function LicenseAccordion({
    getLicensebusinessId,
    licenses,
    expanded,
    setExpanded,
    handleAccordionChange,
    setLicenses,
    businesssid,
    licensebusinesssid,
    id,
    fileId,
    deatils,
    setLanguageType,
    languageType
}) {
    const menuItems = useSelector((state) => state.menuReducer.items);
    const createMenuItem = menuItems?.find((item) => item.name.toLowerCase() === 'subscriptions');
    const isDisabled = createMenuItem?.access_type === 'read_write';
    const { productid, busUid } = useParams();
    const businessid = getDecryptedCookie('bi') || busUid;

    const organizationItems = useSelector((state) => state.organizationReducer.items);

    const [showPicker, setShowPicker] = useState(false);

    const handleToggleColorsPicker = () => {
        setShowPicker(!showPicker);
    };
    const navigate = useNavigate();
    const classes = useStyles();
    const [color, setColor] = useState('#ffffff');
    const [headerImage, setHeaderImage] = useState(null);
    const [pickerVisible, setPickerVisible] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedOption, setSelectedOption] = useState('');
    const [businessuuid, setBusinessuuid] = useState([]);
    const [selectedImages, setSelectedImages] = useState([]);
    const [licensecopy, setLicenseCopy] = useState([]);
    const [licensecopys, setLicenseCopys] = useState([]);
    const [licenseCopyUrl, setLicenseCopyUrl] = useState(null);
    const [licensePrintModal, setLicensePrintModal] = useState(false);
    const [preview, setPreview] = useState([]);
    const [loanStartDate, setLoanStartDate] = useState(null);
    const [alertValidation, setAlertValidation] = useState([]);
    const [printBillModal, setPrintBillModal] = useState(false);
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const [pendingValue, setPendingValue] = useState({ value: '', field: '' });

    const [language, setLanguage] = useState('ta');

    const [licenseuuid, setLicenseUuid] = useState('');
    const [billLicenceID, setBillLicenceID] = useState('');
    const [paperbillType, setPaperbillType] = useState('');
    const [officeCopy, setOfficeCopy] = useState(false);

    useEffect(() => {
        removeCookie('lic');
    }, []);

    const handleOpen = (id) => {
        setSide('front');
        setOfficeCopy(false);
        setPreview(formik.values.licenses[id]);
        setBillLicenceID(formik.values.licenses[id].licId);
        setLicensePrintModal(true);
        setPrintBillModal(true);
        setPaperbillType(formik.values.licenses[id]?.billtype);
        // handleBillPreview();
    };
    const handleOfficeCopyOpen = (id) => {
        setOfficeCopy(true);
        setSide('front');
        setPreview(formik.values.licenses[id]);
        setBillLicenceID(formik.values.licenses[id].licId);
        setLicensePrintModal(true);
        setPrintBillModal(true);
        setPaperbillType(formik.values.licenses[id]?.billtype);
        // handleBillPreview();
    };

    const handlePrintBillModalClose = () => {
        setPrintBillModal(false);
    };
    const [fontColorError, setFontColorError] = useState(false);
    const handleClose = () => {
        setLicensePrintModal(false);
    };

    const [licensePrintModalBack, setLicensePrintModalBack] = useState(false);
    const [side, setSide] = useState('front');
    const handleBackOpen = (id) => {
        setSide('back');
        setPreview(formik.values.licenses[id]);
        setBillLicenceID(formik.values.licenses[id].licId);
        setPrintBillModal(true);
        // setLicensePrintModalBack(true);
        // navigate('/subscriptions/editprint/backside');
    };

    const handleBackClose = () => {
        setLicensePrintModalBack(false);
    };

    const [isEditable, setIsEditable] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [savedimage, setSavedImage] = useState(false);
    const [selectedLicense, setSelectedLicense] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLicenseModalOpen, setIsLicenseModalOpen] = useState(false);

    const dispatch = useDispatch();
    const proid = getDecryptedCookie('proid') || productid;

    const handleOpenmodal = (license) => {
        setSelectedLicense(license);
        setOpenModal(true);
    };
    const handleDeleteLicense = (index) => {
        const updatedLicenses = licenses.filter((_, i) => i !== index);
        setLicenses(updatedLicenses);
    };
    const togglePicker = () => {
        setPickerVisible(!pickerVisible);
    };

    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
    const [imagePreviews, setImagePreviews] = useState([
        { url: BillImg1, name: 'bill1.png' },
        { url: BillImg2, name: 'bill2.png' },
        { url: BillImg3, name: 'bill3.png' }
    ]);
    const handleImageClick = (index) => {
        setSelectedImageIndex(index);
        handleFileChange(index);
    };

    const handleFileChange = (index) => {
        const selectedImage = imagePreviews[index];
        const imageUrl = selectedImage.url;
        const imageName = selectedImage.name;

        fetch(imageUrl)
            .then((res) => res.blob())
            .then((blob) => {
                const file = new File([blob], imageName, { type: blob.type });
                processFile(file);
            })
            .catch((error) => {
                console.error('Error fetching image:', error);
            });
    };

    const processFile = (file) => {
        if (file) {
            setFileName(file.name);
            if (!selectedFontColor || selectedFontColor === '#000000') {
                setFontColorError(true);
                setUploadedImage();
                setSelectedImageIndex(null);
                return;
            }

            setFontColorError(false);

            const reader = new FileReader();
            reader.onloadend = () => {
                const uploadedImageUrl = reader.result;
                setUploadedImage(uploadedImageUrl);

                if (selectedFontColor && !isUploading) {
                    applyColorToImageEdit(uploadedImageUrl, selectedFontColor);
                } else {
                    const formData = new FormData();
                    formData.append('files', file);
                    formData.append('business_id', businessid);
                    fileUploadBill(formData);
                }
            };
            reader.readAsDataURL(file);
        }
    };
    const applyColorToImageEdit = (imageSrc, color) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = imageSrc;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0);
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            const colorRGB = hexToRgb(color);
            for (let i = 0; i < data.length; i += 4) {
                data[i] = colorRGB.r;
                data[i + 1] = colorRGB.g;
                data[i + 2] = colorRGB.b;
            }
            ctx.putImageData(imageData, 0, 0);

            canvas.toBlob((blob) => {
                if (blob) {
                    const modifiedImageUrl = URL.createObjectURL(blob);
                    setUploadedImage(modifiedImageUrl);
                    const formData = new FormData();
                    formData.append('files', blob, 'colored-image.png');
                    formData.append('business_id', businessid);
                    fileUploadBill(formData);
                }
            }, 'image/png');
        };
    };
    const [editHeader, setEditHeader] = useState();
    const [editAlert, setEditAlert] = useState(false);
    const [editAlertLic, setEditAlertLic] = useState(false);

    const clearBillHeader = () => {
        setEditHeader(preview?.billImg);
        setEditAlert(false);
        setSelectedImages([]);
    };
    const handleSelectImage = (uuid, url, option, index) => {
        setEditHeader(url);

        if (preview?.billImg !== url) {
            setEditAlert(true);
        }

        setSelectedOption((prevOption) => (prevOption === option ? '' : option));

        setSelectedImages((prevSelected) => {
            if (prevSelected.length > 0 && prevSelected[0].file_uuid === uuid) {
                return [];
            } else {
                const selectedImage = headerImages.find((img) => img.file_uuid === uuid);
                formik.setFieldValue(`licenses[${index}].businesslogo`, selectedImage.file_uuid);

                setPreview((prev) => ({
                    ...prev,
                    billImg: selectedImage.actual_path
                }));

                return [selectedImage];
            }
        });
    };

    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        return d.toISOString().split('T')[0];
    };
    const manageLicense = useCallback(
        (licenseData, index) => {
            dispatch(showLoader());

            const billFileId = selectedImages.length > 0 ? selectedImages[0].file_uuid : licenses[index].bill_file_id;

            const data = {
                license_number: licenses[index].number,
                license_name: licenses[index].name,
                license_alias_name: licenseData?.licensealiasname,
                license_valid_till: formatDate(licenseData.licensevalidatill),
                system_loan_starting_date: formatDate(licenseData?.systemloanstaringdate),
                previous_loan_date_range_from: licenseData?.previousloandaterangefrom
                    ? formatDate(licenseData.previousloandaterangefrom)
                    : null,
                previous_loan_date_range_to: licenseData?.previousloandaterangeto
                    ? formatDate(licenseData.previousloandaterangeto)
                    : null,
                previous_loan_number_from: licenseData?.previousloannumberfrom
                    ? licenseData?.previousloannumberfrom
                    : null,
                previous_loan_number_to: licenseData?.previousloannumberto ? licenseData?.previousloannumberto : null,
                bill_print_font_color: licenseData?.billprint,
                bill_type: licenseData?.billtype,
                business_id: businessid,
                bill_file_id: billFileId ? billFileId : selectedImages,
                is_backside_table_allowed: licenseData.isBacksideTableAllowed,
                is_glod_item_pefix: licenseData.isGoldItemPrefix,
                is_silver_item_pefix: licenseData.isSilverItemPrefix
            };
            licenseApi
                .manageLicense(proid, data)
                .then((response) => {
                    dispatch(hideLoader());
                    dispatch(
                        showSnackbar({
                            message: 'License Created Successfully ',
                            autoHideDuration: 3000,
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            },
                            variant: 'success'
                        })
                    );
                    getLicensebusinessId(proid, businessid);
                    handleEditClick();
                })
                .catch((error) => {
                    dispatch(hideLoader());
                    console.error('Error submitting data:', error);
                    dispatch(
                        showSnackbar({
                            message:
                                error.response.data.res.message === 'Duplicate License'
                                    ? 'License Already Exist'
                                    : error.response.data.res.message,
                            autoHideDuration: 3000,
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            },
                            variant: 'error'
                        })
                    );
                });
        },
        [licenses, selectedImages]
    );

    const [fileName, setFileName] = useState(null);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [uploadedImageUuid, setUploadedImageUuid] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [selectedFontColor, setSelectedFontColor] = useState('#000000');
    const fileInputRef = useRef(null);
    const [billHeader, setBillHeader] = useState(false);

    const handleIconClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const applyColorToImage = (imageUrl, color, callback) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = imageUrl;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            ctx.globalCompositeOperation = 'source-atop';
            ctx.fillStyle = color;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            canvas.toBlob((blob) => {
                if (blob) {
                    const modifiedFile = new File([blob], 'modified_image.png', {
                        type: 'image/png'
                    });

                    const modifiedImageUrl = URL.createObjectURL(blob);
                    setUploadedImage(modifiedImageUrl);
                    callback(modifiedFile);
                }
            }, 'image/png');
        };
    };
    const hexToRgb = (hex) => {
        hex = hex.replace(/^#/, '');
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        return { r, g, b };
    };

    const handleFileChangebill = (event) => {
        if (!selectedFontColor || selectedFontColor === '#000000') {
            setFontColorError(true);
            return;
        }
        setFontColorError(false);
        const fileInput = event.target;
        const file = fileInput.files[0];

        if (file) {
            fileInput.value = '';
            setFileName(file.name);
            const uploadedImageUrl = URL.createObjectURL(file);
            setPreview((prev) => ({
                ...prev,
                billImg: uploadedImageUrl
            }));
            applyColorToImage(uploadedImageUrl, selectedFontColor, (processedFile) => {
                const formData = new FormData();
                formData.append('files', processedFile);
                formData.append('business_id', businessid);
                fileUploadBill(formData);
                setEditAlert(true);
            });
        }
    };

    const fileUploadBill = useCallback(
        async (formData) => {
            if (isUploading) return;

            setIsUploading(true);
            dispatch(showLoader());

            try {
                const res = await fileuploadApi.fileUpload(formData);
                if (res.data && res.data.data && res.data.data[0].uuid) {
                    const uploadedImageUuid = res.data.data[0].uuid;
                    const uploadedImageUrl = res.data.data[0].public_url;
                    setUploadedImage(uploadedImageUrl);
                    setUploadedImageUuid(uploadedImageUuid);
                    formik.setFieldValue('uuid', uploadedImageUuid);
                    setBillHeader(true);
                    setIsUploading(false);
                    dispatch(hideLoader());

                    dispatch(
                        showSnackbar({
                            message: 'File uploaded successfully',
                            autoHideDuration: 3000,
                            anchorOrigin: { vertical: 'top', horizontal: 'right' },
                            variant: 'success'
                        })
                    );
                }
            } catch (error) {
                console.error('Error uploading image:', error);
                setIsUploading(false);
                dispatch(hideLoader());
            }
        },
        [isUploading]
    );

    const fileUpload = useCallback((formData) => {
        dispatch(showLoader());
        fileuploadApi
            .fileUpload(formData)
            .then((res) => {
                dispatch(hideLoader());
                if (res.data && res.data.data && res.data.data[0].uuid) {
                    setLicenseCopys(res.data.data[0].uuid);
                    setBillHeader(true);
                } else {
                    console.error('File UUID not found in response');
                }
            })
            .catch((error) => {
                dispatch(hideLoader());
                console.error('Error submitting data:', error);
            });
    }, []);

    useEffect(() => {
        if (licenses) {
            formik.setFieldValue('licensenumber', licenses.number);
            formik.setFieldValue('licensename', licenses.name);
        }
    }, [licenses, organizationItems]);

    const [headerImages, setHeaderImages] = useState([]);

    const getHeaderImages = useCallback((proid) => {
        const onSuccess = (res) => {
            if (res.data.status === true) {
                setHeaderImages(res.data.data.data);
            } else {
                console.error('Failed to fetch images');
            }
        };

        const onFailure = (err) => {
            console.error('Failed to fetch data', err);
            setHeaderImages([]);
        };

        headerApi.headerImage(proid).then(onSuccess).catch(onFailure);
    }, []);

    useEffect(() => {
        getHeaderImages(proid);
    }, [getHeaderImages, organizationItems]);

    const formik = useFormik({
        initialValues: {
            licenses: Array?.isArray(licensebusinesssid)
                ? licensebusinesssid?.map(() => ({
                      licensealiasname: '',
                      licensevalidatill: null,
                      systemloanstaringdate: null,
                      previousloandaterangefrom: null,
                      previousloandaterangeto: null,
                      previousloannumberfrom: '',
                      previousloannumberto: '',
                      billprint: '',
                      billtype: '',
                      businesslogo: null,
                      billheaderimage: '',
                      btnNumber: null,
                      licId: null,
                      billImg: null,
                      licensecopypath: null,
                      licId: '',
                      loan: null,
                      isGoldItemPrefix: false,
                      isSilverItemPrefix: false,
                      isBacksideTableAllowed: false
                  }))
                : []
        },
        validationSchema: Yup.object({
            licensealiasname: Yup.string()
                .min(5, 'License Alias must be at least 5 characters long')
                .max(50, 'License Alias cannot exceed 50 characters')
                .required('License Alias Name required'),
            licensevalidatill: Yup.date().required('License valid till date is required'),

            systemloanstaringdate: Yup.date().required('System loan starting date is required'),
            previousloandaterangefrom: Yup.date().required('Previous loan date range from is required'),
            previousloandaterangeto: Yup.date().required('Previous loan date range to is required'),
            billprint: Yup.string()
                .required('Bill print color is required')
                .matches(/^#[0-9A-F]{6}$/i, 'Invalid color format'),
            billtype: Yup.string().required('Bill type is required'),
            billheaderimage: Yup.string().required('Bill Header Image  is required'),
            businesslogo: Yup.mixed().required('License Copy is required'),
            licId: Yup.string(),
            loan: Yup.boolean()
        }),
        onSubmit: (values) => {
            if (!formik.isValid) {
                return;
            }
        }
    });
    useEffect(() => {
        if (businesssid) {
            formik.setFieldValue('licensealiasname', businesssid.license_alias_name);
            formik.setFieldValue('licensevalidatill', businesssid.license_valid_till);
            formik.setFieldValue('businesslogo', businesssid.license_copy);
            formik.setFieldValue('systemloanstaringdate', businesssid.system_loan_starting_date);
            formik.setFieldValue('previousloandaterangefrom', businesssid.previous_loan_date_range_from);
            formik.setFieldValue('previousloandaterangeto', businesssid.previous_loan_date_range_to);
            formik.setFieldValue('previousloannumberfrom', businesssid.previous_loan_number_from);
            formik.setFieldValue('isGoldItemPrefix', businesssid.is_glod_item_pefix);
            formik.setFieldValue('billtype', businesssid.bill_type);
            formik.setFieldValue('isSilverItemPrefix', businesssid.is_silver_item_pefix);
            formik.setFieldValue('isBacksideTableAllowed', businesssid.is_backside_table_allowed);
        }
    }, [businesssid, organizationItems]);
    const [sample, setSample] = useState();
    useEffect(() => {
        if (Array?.isArray(licensebusinesssid) && licensebusinesssid.length > 0) {
            setLicenseUuid((prev) => {
                const updatedUuids = [...prev]; // Copy previous state
                licensebusinesssid.forEach((licenseData, index) => {
                    updatedUuids[index] = licenseData.license_uuid; // Update specific index
                });
                return updatedUuids;
            });

            setLicenseCopy((prev) => {
                const updatedCopies = [...prev]; // Copy previous state
                licensebusinesssid.forEach((licenseData, index) => {
                    updatedCopies[index] = licenseData?.license_copy; // Update specific index
                });
                return updatedCopies;
            });

            licensebusinesssid.forEach((licenseData, index) => {
                setSample(licenseData.file_uuid);
                formik.setFieldValue(`licenses[${index}].loan`, licenseData?.loan_exists);
                formik.setFieldValue(`licenses[${index}].licId`, licenseData?.license_uuid);
                formik.setFieldValue(`licenses[${index}].number`, licenseData?.license_number);
                formik.setFieldValue(`licenses[${index}].name`, licenseData?.license_name);
                formik.setFieldValue(`licenses[${index}].licensealiasname`, licenseData?.license_alias_name);
                formik.setFieldValue(
                    `licenses[${index}].licensevalidatill`,
                    licenseData?.license_valid_till ? new Date(licenseData.license_valid_till) : null
                );
                formik.setFieldValue(`licenses[${index}].businesslogo`, licenseData?.license_copy);
                formik.setFieldValue(
                    `licenses[${index}].systemloanstaringdate`,
                    licenseData?.system_loan_starting_date ? new Date(licenseData.system_loan_starting_date) : null
                );
                formik.setFieldValue(
                    `licenses[${index}].previousloandaterangefrom`,
                    licenseData?.previous_loan_date_range_from
                        ? new Date(licenseData.previous_loan_date_range_from)
                        : null
                );
                formik.setFieldValue(
                    `licenses[${index}].previousloandaterangeto`,
                    licenseData?.previous_loan_date_range_to ? new Date(licenseData.previous_loan_date_range_to) : null
                );
                setSelectedImages(licenseData.bill_file_id);
                formik.setFieldValue(
                    `licenses[${index}].previousloannumberfrom`,
                    licenseData?.previous_loan_number_from
                );
                formik.setFieldValue(`licenses[${index}].previousloannumberto`, licenseData?.previous_loan_number_to);
                formik.setFieldValue(`licenses[${index}].billprint`, licenseData?.bill_print_font_color);
                formik.setFieldValue(`licenses[${index}].billtype`, licenseData?.bill_type);
                formik.setFieldValue(`licenses[${index}].billheaderimage`, licenseData?.bill_file_id);
                formik.setFieldValue(`licenses[${index}].billImg`, licenseData?.bill_file_url);
                formik.setFieldValue(`licenses[${index}].licensecopypath`, licenseData?.license_copy_url);
                formik.setFieldValue(`licenses[${index}].licId`, licenseData?.license_uuid);
                formik.setFieldValue(
                    `licenses[${index}].isBacksideTableAllowed`,
                    licenseData?.is_backside_table_allowed
                );
                formik.setFieldValue(`licenses[${index}].isGoldItemPrefix`, licenseData?.is_glod_item_pefix);
                formik.setFieldValue(`licenses[${index}].isSilverItemPrefix`, licenseData?.is_silver_item_pefix);
                formik.setFieldValue(`licenses[${index}].billtype`, licenseData?.bill_type);
            });
        }
    }, [licensebusinesssid, organizationItems]);

    const textColorStyle = { color: formik.values.billprint };

    const isFormValid = () => {
        return (
            formik.values.licensealiasname &&
            formik.values.licensevalidatill &&
            formik.values.businesslogo &&
            formik.values.systemloanstaringdate &&
            formik.values.previousloandaterangefrom &&
            formik.values.previousloandaterangeto &&
            formik.values.previousloannumberfrom &&
            formik.values.previousloannumberto &&
            formik.values.billprint &&
            formik.values.billtype &&
            selectedImages.length > 0
        );
    };

    const handleSaveLicense = (index) => {
        formik.handleSubmit();

        if (formik.isValid && formik.dirty) {
            const licenseData = formik.values;
            manageLicense(licenseData, index);
            formik.resetForm();
        }
    };

    const [editableIndex, setEditableIndex] = useState(null);
    const handleEditClick = (index) => {
        setEditableIndex((prevIndex) => (prevIndex === index ? null : index));
        setExpanded(index);
    };

    const handleUpdateClick = (id) => {
        dispatch(showLoader());
        let errors = [];
        const values = formik.values.licenses[id];
        if (!values) {
            dispatch(hideLoader());
            setAlertValidation(['Invalid License ID.']);
            return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const licenseValidDate = values.licensevalidatill ? new Date(values.licensevalidatill) : null;

        if (!licenseValidDate || isNaN(licenseValidDate.getTime())) {
            errors.push('License Valid Till date is required.');
        } else if (licenseValidDate < today) {
            errors.push('License Valid Till cannot be in the past. Please select today or a future date.');
        }

        const billFileId = uploadedImageUuid ? uploadedImageUuid : selectedImages;
        const previousLoanFrom = values.previousloannumberfrom;
        const previousLoanTo = values.previousloannumberto;
        const previousLoanDateFrom = values.previousloandaterangefrom;
        const previousLoanDateTo = values.previousloandaterangeto;
        const loanNumberRegex = /^[A-Za-z]?\d{5}$/;

        const extractPrefix = (loanNumber) => loanNumber.replace(/\d/g, '') || '';

        const extractNumber = (loanNumber) => parseInt(loanNumber.replace(/\D/g, ''), 10) || 0;
        if (previousLoanDateFrom) {
            if (!previousLoanDateTo) {
                errors.push('Previous Loan Date Range To is required when Previous Loan Date Range From is selected.');
            }
            if (!previousLoanFrom) {
                errors.push('Previous Loan Number From is required when Previous Loan Date Range From is selected.');
            }
            if (!previousLoanTo) {
                errors.push('Previous Loan Number To is required when Previous Loan Date Range From is selected.');
            }
        }
        if (previousLoanFrom) {
            if (!previousLoanTo) {
                errors.push('Previous Loan Number To is required.');
            }

            if (!loanNumberRegex.test(previousLoanFrom)) {
                errors.push('Previous Loan Number From must be in the format of either A00001-Z10000 or 00001-10000.');
            }

            if (previousLoanTo && !loanNumberRegex.test(previousLoanTo)) {
                errors.push('Previous Loan Number To must be in the format of either A00001-Z10000 or 00001-10000.');
            }

            const fromPrefix = extractPrefix(previousLoanFrom);
            const toPrefix = extractPrefix(previousLoanTo || '');
            const fromNumber = extractNumber(previousLoanFrom);
            const toNumber = extractNumber(previousLoanTo || '');

            if (previousLoanFrom === previousLoanTo) {
                errors.push('Previous Loan Number To cannot be the same as Previous Loan Number From.');
            }

            if (fromNumber < 1 || fromNumber > 10000) {
                errors.push('Previous Loan Number From must be within the valid range (1-10000).');
            }

            if (previousLoanTo && (toNumber < 1 || toNumber > 10000)) {
                errors.push('Previous Loan Number To must be within the valid range (1-10000).');
            }

            if (previousLoanTo) {
                if (fromPrefix === toPrefix) {
                    if (fromNumber >= toNumber) {
                        errors.push('Previous Loan Number To must be greater than Previous Loan Number From.');
                    }
                } else {
                    if (fromPrefix > toPrefix) {
                        errors.push('Previous Loan Number To must be greater than Previous Loan Number From.');
                    }
                }
            }
        }
        if (errors.length > 0) {
            setAlertValidation([...errors]);
            dispatch(hideLoader());
            return;
        }

        const data = {
            license_number: values.number,
            license_name: values.name,
            license_alias_name: values.licensealiasname,
            license_valid_till: formatDate(values.licensevalidatill),
            system_loan_starting_date: formatDate(values.systemloanstaringdate),
            previous_loan_date_range_from: values.previousloandaterangefrom
                ? formatDate(values.previousloandaterangefrom)
                : null,
            previous_loan_date_range_to: values.previousloandaterangeto
                ? formatDate(values.previousloandaterangeto)
                : null,
            previous_loan_number_from: values.previousloannumberfrom ? values.previousloannumberfrom : null,
            previous_loan_number_to: values.previousloannumberto ? values.previousloannumberto : null,
            bill_print_font_color: values.billprint,
            bill_type: values.billtype,
            license_copy: licensecopys.length !== 0 ? licensecopys : licensecopy[licensecopy.length - 1],
            business_id: businessid,
            bill_file_id: billFileId,
            is_backside_table_allowed: values.isBacksideTableAllowed,
            is_glod_item_pefix: values.isGoldItemPrefix,
            is_silver_item_pefix: values.isSilverItemPrefix
        };

        const updateData = {
            license_valid_till: formatDate(values.licensevalidatill),
            bill_print_font_color: values.billprint,
            bill_file_id: billFileId,
            bill_type: values.billtype,
            license_copy: licensecopys.length !== 0 ? licensecopys : licensecopy[licensecopy.length - 1],
            is_backside_table_allowed: values.isBacksideTableAllowed,
            is_glod_item_pefix: values.isGoldItemPrefix,
            is_silver_item_pefix: values.isSilverItemPrefix
        };
        const onSuccess = (response) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: 'License Updated Successfully ',
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'success'
                })
            );
            getLicensebusinessId(proid, businessid);
            handleEditClick();
            setBillHeader(false);
            setSelectedImageIndex(null);
        };
        const onFailure = (error) => {
            dispatch(hideLoader());
            console.error('Error submitting data:', error);
            dispatch(
                showSnackbar({
                    message: error.response.data.res.message,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'error'
                })
            );
        };
        if (values?.loan === true) {
            licenseApi.renewalLicense(proid, values?.licId, updateData).then(onSuccess, onFailure);
        } else {
            licenseApi.updateLicense(proid, values?.licId, data).then(onSuccess, onFailure);
        }
    };

    const handleUpdatButtonClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleLicesneOpenModal = () => {
        setIsLicenseModalOpen(true);
    };

    const handleLicenseCloseModal = () => {
        setIsLicenseModalOpen(false);
        setLicenseCopyUrl(null);
    };

    const tempImg = editHeader ? editHeader : preview?.billImg;

    const firstCanvasRef = useRef(null);
    const secondCanvasRef = useRef(null);
    const fontColor = preview?.billprint;

    const changeImageColor = (canvasRef) => {
        if (!fontColor || !canvasRef.current) return;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.src = tempImg;

        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            ctx.globalCompositeOperation = 'source-in';
            ctx.fillStyle = fontColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        };

        img.onerror = () => {
            console.error('Failed to load image:', img.src);
        };
    };

    const [triggerEffect, setTriggerEffect] = useState(false);

    useEffect(() => {
        if (licensePrintModal) {
            setTriggerEffect(true);
            const timer = setTimeout(() => {
                setTriggerEffect(false);
            }, 0);
            return () => clearTimeout(timer);
        }
    }, [licensePrintModal]);

    useEffect(() => {
        changeImageColor(firstCanvasRef);
        changeImageColor(secondCanvasRef);
    }, [triggerEffect]);

    const handleBillPreview = () => {
        navigate('/subscriptions/editprint');
    };

    const handleCloseAlert = () => {
        setOpenAlertDialog(false);
        setPendingValue({ value: '', field: '' });
    };

    const handleConfirmChange = () => {
        if (pendingValue.field) {
            formik.setFieldValue(pendingValue.field, pendingValue.value);
        }
        handleCloseAlert();
    };

    return (
        <Grid item xs={12}>
            {licenses.map((license, index) => (
                <>
                    <Accordion
                        key={index}
                        expanded={expanded === index}
                        onChange={handleAccordionChange(index)}
                        elevation={4}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${index + 1}-content`}
                            id={`panel${index + 1}-header`}
                        >
                            <Typography mt={1}>
                                {license.number && license.name
                                    ? `${license.number}/${license.name}`
                                    : `License ${index + 1}`}
                            </Typography>
                        </AccordionSummary>

                        {expanded === index && license.bill_file_id && isDisabled && (
                            <EditImageModal
                                open={isModalOpen}
                                headerId={license.bill_file_id}
                                businesssid={businesssid}
                                onClose={handleCloseModal}
                            />
                        )}

                        <Box sx={{ display: 'flex', width: '100%' }}>
                            {licenses[index]?.loan_exists && (
                                <Typography variant='subtitle2' color='error' sx={{ marginLeft: '15px' }}>
                                    This license has an existing loan entry. Updating these fields will also affect
                                     existing loan receipts too. Please review carefully before proceeding.
                                </Typography>
                            )}
                            {licenses[index] && isDisabled && (
                                <IconButton sx={{ marginLeft: 'auto' }} onClick={() => handleEditClick(index)}>
                                    <EditIcon />
                                </IconButton>
                            )}
                        </Box>

                        <AccordionDetails>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4} md={4}>
                                    <TextField
                                        label='License Number'
                                        name={`licenses[${index}].number`}
                                        value={formik.values.licenses?.[index]?.number || ''}
                                        disabled={licenses[index]?.loan_exists || editableIndex !== index}
                                        onChange={(e) =>
                                            formik.setFieldValue(`licenses[${index}].number`, e.target.value)
                                        }
                                        onBlur={formik.handleBlur}
                                        fullWidth
                                        error={
                                            formik.touched.licenses?.[index]?.number &&
                                            Boolean(formik.errors.licenses?.[index]?.number)
                                        }
                                        helperText={
                                            formik.touched.licenses?.[index]?.number &&
                                            formik.errors.licenses?.[index]?.number
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4} md={4}>
                                    <TextField
                                        disabled={licenses[index]?.loan_exists || editableIndex !== index}
                                        label='License Name'
                                        name={`licenses[${index}].name`}
                                        value={formik.values.licenses?.[index]?.name || ''}
                                        onChange={(e) =>
                                            formik.setFieldValue(`licenses[${index}].name`, e.target.value)
                                        }
                                        onBlur={formik.handleBlur}
                                        fullWidth
                                        error={
                                            formik.touched.licenses?.[index]?.name &&
                                            Boolean(formik.errors.licenses?.[index]?.name)
                                        }
                                        helperText={
                                            formik.touched.licenses?.[index]?.name &&
                                            formik.errors.licenses?.[index]?.name
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4} md={4}>
                                    <TextField
                                        label='License Alias Name'
                                        name={`licenses[${index}].licensealiasname`}
                                        value={formik.values.licenses?.[index]?.licensealiasname || ''}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={
                                            formik.touched.licenses?.[index]?.licensealiasname &&
                                            Boolean(formik.errors.licenses?.[index]?.licensealiasname)
                                        }
                                        helperText={
                                            formik.touched.licenses?.[index]?.licensealiasname &&
                                            formik.errors.licenses?.[index]?.licensealiasname
                                        }
                                        fullWidth
                                        disabled={licenses[index]?.loan_exists || editableIndex !== index}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4} md={4}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '100%'
                                        }}
                                    >
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            {/* <DatePicker
                      format="dd/MM/yyyy"
                        label="License Valid Till"
                        value={formik.values.licenses?.[index]?.licensevalidatill || null}
                        onChange={(date) => {
                          const today = new Date();
                          today.setHours(0, 0, 0, 0);

                          if (date && date < today) {

                            setAlertValidation(["License Valid Till cannot be in the past, Please Choose the Date"]);
                            formik.setFieldValue(`licenses[${index}].licensevalidatill`, null);
                          } else {
                            setAlertValidation([]);
                            formik.setFieldValue(`licenses[${index}].licensevalidatill`, date);
                          }
                        }}
                        minDate={new Date()}
                        disabled={editableIndex !== index}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            inputProps={{ ...params.inputProps, readOnly: true }} // Prevent manual input
                            onClick={params.inputProps.onClick}
                            error={
                              formik.touched.licenses?.[index]?.licensevalidatill &&
                              Boolean(formik.errors.licenses?.[index]?.licensevalidatill)
                            }
                            helperText={
                              formik.touched.licenses?.[index]?.licensevalidatill &&
                              formik.errors.licenses?.[index]?.licensevalidatill
                            }
                          />
                        )}
                      /> */}
                                            <DatePicker
                                                label='License Valid Till'
                                                value={formik.values.licenses?.[index]?.licensevalidatill || null}
                                                onChange={(date) => {
                                                    const today = new Date();
                                                    today.setHours(0, 0, 0, 0);

                                                    if (date && date < today) {
                                                        setAlertValidation([
                                                            'License Valid Till cannot be in the past, Please Choose the Date'
                                                        ]);
                                                        formik.setFieldValue(
                                                            `licenses[${index}].licensevalidatill`,
                                                            null
                                                        );
                                                    } else {
                                                        setAlertValidation([]);
                                                        formik.setFieldValue(
                                                            `licenses[${index}].licensevalidatill`,
                                                            date
                                                        );
                                                    }
                                                }}
                                                format='dd/MM/yyyy'
                                                minDate={new Date()}
                                                disabled={editableIndex !== index}
                                                componentsProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        inputProps: {
                                                            readOnly: true // Prevent typing
                                                        },
                                                        onClick: (e) => {
                                                            e.stopPropagation(); // Prevent opening calendar on text field click
                                                        }
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                </Grid>
                                {editableIndex === index && (
                                    <Grid item xs={12} sm={4} md={4}>
                                        <TextField
                                            type='file'
                                            label='License Copy'
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            disabled={editableIndex !== index}
                                            onChange={(event) => {
                                                const file = event.currentTarget.files[0];
                                                if (file) {
                                                    const MAX_SIZE = 3 * 1024 * 1024;
                                                    if (file.size > MAX_SIZE) {
                                                        alert('File size should not exceed 3MB.');
                                                        return;
                                                    }

                                                    const formData = new FormData();
                                                    formData.append('files', file);
                                                    formData.append('business_id', businessid);

                                                    formik.setFieldValue('businesslogo', file);

                                                    fileUpload(formData);
                                                    setEditAlertLic(true);
                                                }
                                            }}
                                            onBlur={() => formik.setFieldTouched('businesslogo', true)}
                                            name='businesslogo'
                                            error={formik.touched.businesslogo && Boolean(formik.errors.businesslogo)}
                                            inputProps={{
                                                accept: 'image/png, image/jpeg,application/pdf'
                                            }}
                                        />

                                        {formik.touched.businesslogo && formik.errors.businesslogo && (
                                            <Typography sx={{ color: 'red', fontSize: '13px' }}>
                                                {formik.errors.businesslogo}
                                            </Typography>
                                        )}
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={4} md={4}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '100%'
                                        }}
                                    >
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            {/* <DatePicker
                      format="dd/MM/yyyy"
                        label="Previous Loan Date Range From"
                        value={formik.values.licenses?.[index]?.previousloandaterangefrom || null}
                        disabled={licenses[index]?.loan_exists || editableIndex !== index}
                        onChange={(date) => {
                          const today = new Date();
                          today.setHours(0, 0, 0, 0);
                          const yesterday = subDays(today, 1);

                          if (date && date >= today) {
                            setAlertValidation(["Previous Loan Date Range From cannot be today or a future date."]);
                            formik.setFieldValue(`licenses[${index}].previousloandaterangefrom`, null);
                          } else {
                            setAlertValidation([]);
                            formik.setFieldValue(`licenses[${index}].previousloandaterangefrom`, date);
                            formik.setFieldTouched(`licenses[${index}].previousloandaterangefrom`, true);
                          }
                        }}
                        maxDate={subDays(new Date(), 1)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            onBlur={() =>
                              formik.setFieldTouched(`licenses[${index}].previousloandaterangefrom`, true)
                            }
                            error={
                              formik.touched.licenses?.[index]?.previousloandaterangefrom &&
                              Boolean(formik.errors.licenses?.[index]?.previousloandaterangefrom)
                            }
                            helperText={
                              formik.touched.licenses?.[index]?.previousloandaterangefrom &&
                              formik.errors.licenses?.[index]?.previousloandaterangefrom
                            }
                            disabled={licenses[index]?.loan_exists || editableIndex !== index}
                          />
                        )}
                      /> */}

                                            <DatePicker
                                                label='Previous Loan Date Range From'
                                                value={
                                                    formik.values.licenses?.[index]?.previousloandaterangefrom || null
                                                }
                                                disabled={licenses[index]?.loan_exists || editableIndex !== index}
                                                onChange={(date) => {
                                                    const today = new Date();
                                                    today.setHours(0, 0, 0, 0);
                                                    const yesterday = subDays(today, 1);

                                                    if (date && date >= today) {
                                                        setAlertValidation([
                                                            'Previous Loan Date Range From cannot be today or a future date.'
                                                        ]);
                                                        formik.setFieldValue(
                                                            `licenses[${index}].previousloandaterangefrom`,
                                                            null
                                                        );
                                                        // Clear dependent fields
                                                        formik.setFieldValue(
                                                            `licenses[${index}].previousloandaterangeto`,
                                                            null
                                                        );
                                                        formik.setFieldValue(
                                                            `licenses[${index}].previousloannumberfrom`,
                                                            ''
                                                        );
                                                        formik.setFieldValue(
                                                            `licenses[${index}].previousloannumberto`,
                                                            ''
                                                        );
                                                    } else {
                                                        setAlertValidation([]);
                                                        formik.setFieldValue(
                                                            `licenses[${index}].previousloandaterangefrom`,
                                                            date
                                                        );
                                                        formik.setFieldTouched(
                                                            `licenses[${index}].previousloandaterangefrom`,
                                                            true
                                                        );
                                                        if (!date) {
                                                            formik.setFieldValue(
                                                                `licenses[${index}].previousloandaterangeto`,
                                                                null
                                                            );
                                                            formik.setFieldValue(
                                                                `licenses[${index}].previousloannumberfrom`,
                                                                ''
                                                            );
                                                            formik.setFieldValue(
                                                                `licenses[${index}].previousloannumberto`,
                                                                ''
                                                            );
                                                        }
                                                    }
                                                }}
                                                format='dd/MM/yyyy'
                                                maxDate={subDays(new Date(), 1)}
                                                componentsProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        inputProps: {
                                                            readOnly: true
                                                        },
                                                        onClick: (e) => {
                                                            e.stopPropagation();
                                                        }
                                                    },
                                                    actionBar: {
                                                        actions: ['clear']
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    {formik.touched.previousloandaterangefrom &&
                                        formik.errors.previousloandaterangefrom && (
                                            <Typography sx={{ color: 'red', fontSize: '13px' }}>
                                                {formik.errors.previousloandaterangefrom}
                                            </Typography>
                                        )}
                                </Grid>

                                {formik.values.licenses?.[index]?.previousloandaterangefrom && (
                                    <>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    width: '100%'
                                                }}
                                            >
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    {/* <DatePicker
                          format="dd/MM/yyyy"
                            label="Previous Loan Date Range To"
                            value={formik.values.licenses?.[index]?.previousloandaterangeto || null}
                            disabled={licenses[index]?.loan_exists || editableIndex !== index}
                            onChange={(date) => {
                              const today = new Date();
                              today.setHours(0, 0, 0, 0);
                              const yesterday = subDays(today, 1);

                              if (date && date >= today) {
                                setAlertValidation(["Previous Loan Date Range To cannot be today or a future date."]);
                                formik.setFieldValue(`licenses[${index}].previousloandaterangeto`, null);
                              } else {
                                setAlertValidation([]);
                                formik.setFieldValue(`licenses[${index}].previousloandaterangeto`, date);
                                formik.setFieldTouched(`licenses[${index}].previousloandaterangeto`, true);
                              }
                            }}
                            maxDate={subDays(new Date(), 1)}
                            minDate={
                              formik.values.licenses?.[index]?.previousloandaterangefrom
                                ? new Date(formik.values.licenses[index]?.previousloandaterangefrom)
                                : null
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth inputProps={{ ...params.inputProps, readOnly: true }} // Prevent manual input
                                onClick={params.inputProps.onClick}
                                error={
                                  formik.touched.licenses?.[index]?.previousloandaterangeto &&
                                  Boolean(formik.errors.licenses?.[index]?.previousloandaterangeto)
                                }
                                helperText={
                                  formik.touched.licenses?.[index]?.previousloandaterangeto &&
                                  formik.errors.licenses?.[index]?.previousloandaterangeto
                                }
                              />
                            )}
                          /> */}
                                                    <DatePicker
                                                        label='Previous Loan Date Range To'
                                                        value={
                                                            formik.values.licenses?.[index]?.previousloandaterangeto ||
                                                            null
                                                        }
                                                        disabled={
                                                            licenses[index]?.loan_exists || editableIndex !== index
                                                        }
                                                        onChange={(date) => {
                                                            const today = new Date();
                                                            today.setHours(0, 0, 0, 0);

                                                            if (date && date >= today) {
                                                                setAlertValidation([
                                                                    'Previous Loan Date Range To cannot be today or a future date.'
                                                                ]);
                                                                formik.setFieldValue(
                                                                    `licenses[${index}].previousloandaterangeto`,
                                                                    null
                                                                );
                                                            } else {
                                                                setAlertValidation([]);
                                                                formik.setFieldValue(
                                                                    `licenses[${index}].previousloandaterangeto`,
                                                                    date
                                                                );
                                                                formik.setFieldTouched(
                                                                    `licenses[${index}].previousloandaterangeto`,
                                                                    true
                                                                );
                                                            }
                                                        }}
                                                        format='dd/MM/yyyy'
                                                        maxDate={subDays(new Date(), 1)}
                                                        minDate={
                                                            formik.values.licenses?.[index]?.previousloandaterangefrom
                                                                ? new Date(
                                                                      formik.values.licenses[
                                                                          index
                                                                      ]?.previousloandaterangefrom
                                                                  )
                                                                : null
                                                        }
                                                        componentsProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                inputProps: {
                                                                    readOnly: true
                                                                },
                                                                onClick: (e) => {
                                                                    e.stopPropagation();
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Box>

                                            {formik.touched.licenses?.[index]?.previousloandaterangeto &&
                                                formik.errors.licenses?.[index]?.previousloandaterangeto && (
                                                    <Typography sx={{ color: 'red', fontSize: '13px' }}>
                                                        {formik.errors.licenses?.[index]?.previousloandaterangeto}
                                                    </Typography>
                                                )}
                                        </Grid>

                                        <Grid item xs={12} sm={4} md={4}>
                                            <TextField
                                                label='Previous Loan Number From'
                                                name={`licenses[${index}].previousloannumberfrom`}
                                                value={formik.values.licenses?.[index]?.previousloannumberfrom || ''}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={
                                                    formik.touched.licenses?.[index]?.previousloannumberfrom &&
                                                    Boolean(formik.errors.licenses?.[index]?.previousloannumberfrom)
                                                }
                                                helperText={
                                                    formik.touched.licenses?.[index]?.previousloannumberfrom &&
                                                    formik.errors.licenses?.[index]?.previousloannumberfrom
                                                }
                                                fullWidth
                                                disabled={licenses[index]?.loan_exists || editableIndex !== index}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={4} md={4}>
                                            <TextField
                                                label='Previous Loan Number To'
                                                name={`licenses[${index}].previousloannumberto`}
                                                value={formik.values.licenses?.[index]?.previousloannumberto || ''}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={
                                                    formik.touched.licenses?.[index]?.previousloannumberto &&
                                                    Boolean(formik.errors.licenses?.[index]?.previousloannumberto)
                                                }
                                                helperText={
                                                    formik.touched.licenses?.[index]?.previousloannumberto &&
                                                    formik.errors.licenses?.[index]?.previousloannumberto
                                                }
                                                fullWidth
                                                disabled={licenses[index]?.loan_exists || editableIndex !== index}
                                            />
                                        </Grid>
                                    </>
                                )}

                                <Grid item xs={12} sm={4} md={4} style={{ position: 'relative' }} key={index}>
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <TextField
                                            name={`licenses[${index}].billprint`}
                                            value={formik.values.licenses?.[index]?.billprint || ''}
                                            fullWidth
                                            disabled={editableIndex !== index}
                                            label='Bill Print (Font) Color'
                                            InputProps={{
                                                readOnly: true
                                            }}
                                            type='color'
                                            error={
                                                formik.touched.licenses?.[index]?.billprint &&
                                                Boolean(formik.errors.licenses?.[index]?.billprint)
                                            }
                                            helperText={
                                                formik.touched.licenses?.[index]?.billprint &&
                                                formik.errors.licenses?.[index]?.billprint
                                            }
                                            onChange={(e) => {
                                                const color = e.target.value;
                                                formik.setFieldValue(`licenses[${index}].billprint`, color);
                                                setSelectedFontColor(color);
                                                setSelectedImageIndex(null);
                                            }}
                                            onClick={() => setShowPicker(true)}
                                            onBlur={() => formik.setFieldTouched(`licenses[${index}].billprint`, true)}
                                        />
                                        {showPicker && (
                                            <IconButton
                                                onClick={handleToggleColorsPicker}
                                                sx={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    zIndex: '5',
                                                    color: '#fff'
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        )}
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={4} md={4}>
                                    <FormControl fullWidth>
                                        <InputLabel>Loan Receipt Type</InputLabel>
                                        <Select
                                            label='Loan Receipt Type'
                                            onChange={(event) => {
                                                const selectedValue = event.target.value;

                                                if (formik.values.licenses?.[index]?.loan === true) {
                                                    setPendingValue({
                                                        value: selectedValue,
                                                        field: `licenses[${index}].billtype`
                                                    });
                                                    setOpenAlertDialog(true);
                                                } else {
                                                    formik.setFieldValue(`licenses[${index}].billtype`, selectedValue);
                                                }
                                            }}
                                            onBlur={formik.handleBlur}
                                            name={`licenses[${index}].billtype`}
                                            value={formik.values.licenses?.[index]?.billtype || ''}
                                            error={
                                                formik.touched.licenses?.[index]?.billtype &&
                                                Boolean(formik.errors.licenses?.[index]?.billtype)
                                            }
                                            disabled={editableIndex !== index}
                                        >
                                            <MenuItem value='general'>Receipt Specimen - General (A4 - Split)</MenuItem>
                                            <MenuItem value='customer_image'>
                                                Receipt Specimen - Customer Image (A4 - Split)
                                            </MenuItem>
                                            <MenuItem value='customer_with_item_image'>
                                                Receipt Specimen - Customer & Jewel Image (A4 - Split)
                                            </MenuItem>
                                            <MenuItem value='customer_with_item_image_article_type1'>
                                                Receipt Specimen - Customer & Jewel Image (A4 - Article Continuous Type
                                                1)
                                            </MenuItem>
                                            <MenuItem value='customer_with_item_image_article_type2'>
                                                Receipt Specimen - Customer & Jewel Image (A4 - Article Continuous Type
                                                2)
                                            </MenuItem>
                                        </Select>
                                        <FormHelperText>
                                            {formik.touched.licenses?.[index]?.billtype &&
                                                formik.errors.licenses?.[index]?.billtype}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={4} md={4}>
                                    <Button
                                        variant='contained'
                                        size='small'
                                        sx={{ mt: 1, mr: 1 }}
                                        className={classes.header}
                                        onClick={handleUpdatButtonClick}
                                    >
                                        View Bill Header
                                    </Button>
                                </Grid>

                                <Grid item xs={12} sm={4} md={4}>
                                    <Typography sx={{ fontSize: '8px', color: '#a00', fontWeight: 'bold' }}>
                                        License Copy
                                    </Typography>
                                    <div key={index}>
                                        {editableIndex !== index &&
                                        formik.values?.licenses[index]?.licensecopypath &&
                                        (formik.values?.licenses[index]?.licensecopypath?.endsWith('.jpg') ||
                                            formik.values?.licenses[index]?.licensecopypath?.endsWith('.jpeg') ||
                                            formik.values?.licenses[index]?.licensecopypath?.endsWith('.png') ||
                                            formik.values?.licenses[index]?.licensecopypath?.endsWith('.gif')) ? (
                                            <img
                                                name={formik.values?.licenses[index]?.licensecopypath}
                                                src={formik.values?.licenses[index]?.licensecopypath}
                                                style={{
                                                    maxWidth: '40%',
                                                    height: 'auto',
                                                    marginTop: '8px'
                                                }}
                                                alt='License Copy'
                                            />
                                        ) : (
                                            editableIndex !== index &&
                                            formik.values?.licenses[index]?.licensecopypath?.endsWith('.pdf') && (
                                                <iframe
                                                    src={formik.values?.licenses[index]?.licensecopypath}
                                                    style={{
                                                        width: '100%',
                                                        height: '260px',
                                                        marginTop: '8px'
                                                    }}
                                                    frameBorder='0'
                                                />
                                            )
                                        )}
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={12} md={9} lg={6} my={'auto'}>
                                    <Typography>
                                        Do you want to enable a common item prefix for pledged items in the Loan
                                        Receipt?
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} sm={2} md={1} lg={1} my={'auto'}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={Boolean(formik.values.licenses?.[index]?.isGoldItemPrefix)}
                                                onChange={(e) => {
                                                    formik.setFieldValue(
                                                        `licenses[${index}].isGoldItemPrefix`,
                                                        e.target.checked
                                                    );
                                                }}
                                                name={`licenses[${index}].isGoldItemPrefix`}
                                                disabled={editableIndex !== index}
                                            />
                                        }
                                        labelPlacement='end'
                                        label={
                                            <Typography
                                                sx={{ fontSize: { xs: '12px', sm: '14px', md: '11px', lg: '13.7px' } }}
                                            >
                                                Gold
                                            </Typography>
                                        }
                                    />
                                </Grid>
                                <Grid item xs={6} sm={2} md={1} lg={1} my={'auto'}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={Boolean(formik.values.licenses?.[index]?.isSilverItemPrefix)}
                                                onChange={(e) => {
                                                    formik.setFieldValue(
                                                        `licenses[${index}].isSilverItemPrefix`,
                                                        e.target.checked
                                                    );
                                                }}
                                                name={`licenses[${index}].isSilverItemPrefix`}
                                                disabled={editableIndex !== index}
                                            />
                                        }
                                        labelPlacement='end'
                                        label={
                                            <Typography
                                                sx={{ fontSize: { xs: '12px', sm: '14px', md: '11px', lg: '13.7px' } }}
                                            >
                                                Silver
                                            </Typography>
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} my={'auto'}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={Boolean(
                                                    formik.values.licenses?.[index]?.isBacksideTableAllowed
                                                )}
                                                onChange={(e) => {
                                                    formik.setFieldValue(
                                                        `licenses[${index}].isBacksideTableAllowed`,
                                                        e.target.checked
                                                    );
                                                }}
                                                name={`licenses[${index}].isBacksideTableAllowed`}
                                                disabled={editableIndex !== index}
                                            />
                                        }
                                        labelPlacement='end'
                                        label={<Typography>Do you want to insert table in back print ?</Typography>}
                                    />
                                </Grid>
                                {editableIndex === index && (
                                    <Grid item xs={12} sm={4} md={10}>
                                        <Typography variant='subtitle2' mb={2}>
                                            Bill Header (Image)
                                        </Typography>
                                        <Grid
                                            container
                                            spacing={1}
                                            direction='row'
                                            alignItems='center'
                                            justifyContent='flex-start'
                                            flexWrap='nowrap'
                                            overflow='auto'
                                        >
                                            <Grid
                                                container
                                                spacing={1}
                                                direction='row'
                                                alignItems='center'
                                                justifyContent='flex-start'
                                                flexWrap='nowrap'
                                                overflow='auto'
                                            >
                                                {imagePreviews.map((image, index) => (
                                                    <Grid item key={index}>
                                                        <Card
                                                            style={{
                                                                cursor: 'pointer',
                                                                width: 100,
                                                                height: 100,
                                                                overflow: 'hidden',
                                                                position: 'relative'
                                                            }}
                                                            onClick={() => handleImageClick(index)}
                                                        >
                                                            <CardMedia
                                                                component='img'
                                                                height='100'
                                                                image={image.url}
                                                                alt='Image'
                                                                style={{ objectFit: 'cover' }}
                                                            />
                                                            {selectedImageIndex === index && (
                                                                <Box
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: 0,
                                                                        right: 0,
                                                                        background: 'rgba(0, 0, 0, 0.5)',
                                                                        padding: '5px'
                                                                    }}
                                                                >
                                                                    <CheckCircleIcon style={{ color: 'white' }} />
                                                                </Box>
                                                            )}
                                                        </Card>
                                                    </Grid>
                                                ))}

                                                <Grid item>
                                                    <Card
                                                        sx={{
                                                            cursor: 'pointer',
                                                            width: 100,
                                                            height: 100,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            border: '1px dashed gray',
                                                            position: 'relative'
                                                        }}
                                                    >
                                                        <input
                                                            ref={fileInputRef}
                                                            type='file'
                                                            accept='image/*'
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100%',
                                                                height: '100%',
                                                                opacity: 0
                                                            }}
                                                            onChange={handleFileChangebill}
                                                        />
                                                        <IconButton color='primary' onClick={handleIconClick}>
                                                            <AddIcon />
                                                        </IconButton>
                                                    </Card>
                                                </Grid>

                                                {uploadedImage && (
                                                    <Grid item>
                                                        <Card
                                                            sx={{
                                                                width: 100,
                                                                height: 100,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                overflow: 'hidden',
                                                                position: 'relative'
                                                            }}
                                                        >
                                                            <CardMedia
                                                                component='img'
                                                                image={uploadedImage}
                                                                alt='Uploaded Image'
                                                                sx={{
                                                                    objectFit: 'cover',
                                                                    width: '100%',
                                                                    height: '100%'
                                                                }}
                                                            />
                                                        </Card>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                        {editAlert && !editAlertLic && (
                                            <Grid item xs={12} sm={12} md={12}>
                                                <Typography variant='body2' color='error'>
                                                    <b>Note:</b> Click 'Update' to save the Bill Header after reviewing
                                                    it in the Bill Preview. If you don’t want to update, click 'Clear'.
                                                </Typography>
                                            </Grid>
                                        )}
                                        {fontColorError && (
                                            <div
                                                style={{
                                                    color: 'red',
                                                    fontSize: '14px',
                                                    marginTop: '8px'
                                                }}
                                            >
                                                <p>Please select a font color before select/uploading the image.</p>
                                            </div>
                                        )}

                                        {editAlertLic && !editAlert && (
                                            <Grid item xs={12} sm={12} md={12}>
                                                <Typography variant='body2' color='error'>
                                                    <b>Note:</b> Click 'Update' to save the License Copy.
                                                </Typography>
                                            </Grid>
                                        )}
                                        {editAlertLic && editAlert && (
                                            <Grid item xs={12} sm={12} md={12}>
                                                <Typography variant='body2' color='error'>
                                                    <b>Note:</b> Click 'Update' to save the License Copy and Bill
                                                    Header.
                                                </Typography>
                                            </Grid>
                                        )}

                                        {alertValidation.length > 0 && (
                                            <Box sx={{ mt: 2 }}>
                                                {alertValidation.map((error, index) => (
                                                    <Typography key={index} sx={{ color: 'red', fontSize: '13px' }}>
                                                        {error}
                                                    </Typography>
                                                ))}
                                            </Box>
                                        )}
                                    </Grid>
                                )}

                                <Grid container spacing={2} justifyContent='flex-end'>
                                    {editableIndex === index && (
                                        <Grid item>
                                            <Button
                                                variant='contained'
                                                size='small'
                                                sx={{ mt: 1, mr: 1 }}
                                                className={classes.animatedButton}
                                                onClick={() => handleUpdateClick(index)}
                                            >
                                                Update
                                            </Button>
                                        </Grid>
                                    )}

                                    {editableIndex !== index && (
                                        <Grid item>
                                            <Button
                                                onClick={(e) => handleOpen(index)}
                                                // onClick={handleBillPreview}
                                                variant='contained'
                                                className={classes.animatedButton}
                                                size='small'
                                                sx={{ mt: 1, mr: 1 }}
                                            >
                                                {formik.values.licenses?.[index]?.billtype ===
                                                    'customer_with_item_image_article_type1' ||
                                                formik.values.licenses?.[index]?.billtype ===
                                                    'customer_with_item_image_article_type2'
                                                    ? 'Customer Copy'
                                                    : 'Front Side Preview'}
                                            </Button>
                                        </Grid>
                                    )}

                                    {editableIndex !== index &&
                                        formik.values.licenses?.[index]?.billtype !==
                                            'customer_with_item_image_article_type1' &&
                                        formik.values.licenses?.[index]?.billtype !==
                                            'customer_with_item_image_article_type2' && (
                                            <Grid item>
                                                <Button
                                                    onClick={() => handleBackOpen(index)}
                                                    variant='contained'
                                                    className={classes.animatedButton}
                                                    size='small'
                                                    sx={{ mt: 1, mr: 1 }}
                                                >
                                                    Back Side Preview
                                                </Button>
                                            </Grid>
                                        )}

                                    {editableIndex !== index &&
                                        (formik.values.licenses?.[index]?.billtype ===
                                            'customer_with_item_image_article_type1' ||
                                            formik.values.licenses?.[index]?.billtype ===
                                                'customer_with_item_image_article_type2') && (
                                            <Grid item>
                                                <Button
                                                    onClick={() => handleOfficeCopyOpen(index)}
                                                    variant='contained'
                                                    className={classes.animatedButton}
                                                    size='small'
                                                    sx={{ mt: 1, mr: 1 }}
                                                >
                                                    Office Copy
                                                </Button>
                                            </Grid>
                                        )}
                                    <BackEditBill
                                        open={licensePrintModalBack}
                                        onClose={handleBackClose}
                                        preview={preview}
                                        color={color}
                                        uploadedImage={uploadedImage}
                                        firstCanvasRef={firstCanvasRef}
                                        secondCanvasRef={secondCanvasRef}
                                        license={license}
                                        businessuuid={businessuuid}
                                        licenseuuid={licenseuuid}
                                        setLicenseUuid={setLicenseUuid}
                                        businesssid={deatils}
                                        edit={editableIndex === index}
                                    />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </>
            ))}
            <Typography variant='subtitle2' color='error' sx={{ marginLeft: '15px', marginTop: '15px' }}>
                Kindly ensure the previous loan details. Once you have created at least one loan against this license,
                you will not be able to update previous loan details. Please verify all values before proceeding.
            </Typography>
            {openModal && selectedLicense && (
                <LicenseModal
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                    license={selectedLicense}
                    licenseuuid={licenseuuid}
                    setLicenseUuid={setLicenseUuid}
                />
            )}

            <Dialog open={openAlertDialog} onClose={handleCloseAlert}>
                <DialogTitle textAlign={'center'}>
                    <ErrorOutlinedIcon sx={{ color: 'warning.main', fontSize: 50 }} />
                    <Typography fontSize={20} fontWeight={600} color='primary'>
                        Warning
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography fontSize={16}>
                        Loan receipt type modification may affect existing loan 'Business detailes/receipt alignments'
                        in the Pawn Broker Application. Are you sure you want to proceed?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAlert} color='primary'>
                        No
                    </Button>
                    <Button onClick={handleConfirmChange} color='primary'>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <EditBill
                open={printBillModal}
                onClose={handlePrintBillModalClose}
                side={side}
                licenceUid={billLicenceID}
                paperType={paperbillType}
                officeCopy={officeCopy}
                // preview={preview}
                // color={color}
                // uploadedImage={uploadedImage}
                // firstCanvasRef={firstCanvasRef}
                // secondCanvasRef={secondCanvasRef}
                // license={license}
                // businessuuid={businessuuid}
                // licenseuuid={licenseuuid}
                // setLicenseUuid={setLicenseUuid}
                // businesssid={deatils}
                // language={language}
                // setLanguage={setLanguage}
                // edit={editableIndex === index}
                // setLanguageType={setLanguageType}
                // languageType={languageType}
            />
        </Grid>
    );
}

export default LicenseAccordion;
